import { render, staticRenderFns } from "./Margins.vue?vue&type=template&id=35ea15ed&"
import script from "./Margins.vue?vue&type=script&lang=js&"
export * from "./Margins.vue?vue&type=script&lang=js&"
import style0 from "./Margins.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports